import type { Components } from '@/api/generated/api';
import type { UseQueryReturnType } from '@tanstack/vue-query';
import { computed, toValue, type MaybeRefOrGetter } from 'vue';
import { useQueryWithToast } from '@/composables/useQueryWithToast';
import {
  fetchSchoolSubjectGroupsForClass,
  fetchTenantSchoolSubjectGroupTemplates,
} from '@/api/resources/schoolSubjectGroup.api';
import { schoolSubjectGroupKeys } from './schoolSubjectGroup.keys';

type GroupContextId = MaybeRefOrGetter<number | undefined>;

export const useSchoolSubjectGroupsQuery = (
  classId: GroupContextId,
): UseQueryReturnType<Components.Schemas.SchoolSubjectGroupDto[], Error> =>
  useQueryWithToast({
    queryKey: computed(() => schoolSubjectGroupKeys.classList(toValue(classId))),
    enabled: computed(() => toValue(classId) != null),
    queryFn: () => fetchSchoolSubjectGroupsForClass({ classId: toValue(classId)! }),
  });

export const useTenantSchoolSubjectGroupsQuery = (
  tenantId: GroupContextId,
): UseQueryReturnType<Components.Schemas.SchoolSubjectGroupDto[], Error> =>
  useQueryWithToast({
    queryKey: computed(() => schoolSubjectGroupKeys.tenantList(toValue(tenantId))),
    enabled: computed(() => toValue(tenantId) != null),
    queryFn: () => fetchTenantSchoolSubjectGroupTemplates(),
  });
